import React, { useState, useEffect } from "react";

import CardStatContract from "./CardStatContract";

const CardStatContractAppRe = ({ id, title, totalCurrent, totalLast }) => {
    const [reContractRate, setReContractRate] = useState(false);
    useEffect(() => {
        setReContractRate(totalLast > 0 ? Math.ceil((totalCurrent / totalLast) * 100) : 0);
        return () => {};
    }, [totalCurrent, totalLast, reContractRate]);

    return (
        <div className="w-100">
            <div className="card border-top mb-0" style={{ height: "118px" }}>
                <div className="card-header app-stat pt-1 mb-0">
                    <h4>{title}</h4>
                </div>
                <div className="card-body metric-value h-100 flex-fill" style={{ padding: "10px 15px", marginTop: "8px" }}>
                    <div className="d-flex flex-row-reverse mb-2">
                        <span className="h5 text-dark mr-1">{totalLast != undefined ? totalCurrent + "/" + totalLast : totalCurrent}</span>
                    </div>
                    {totalLast != undefined ? (
                        <div className="progress progress-lg">
                            <div className="progress-bar" role="progressbar" style={{ width: reContractRate + "%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                {reContractRate}%
                            </div>
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
        </div>
    );
};

const CardStatContractApp = ({ appInfo, bizYear }) => {
    useEffect(() => {
        return () => {};
    }, [appInfo, bizYear]);
    let totalCurrent = appInfo.stat[bizYear] ? appInfo.stat[bizYear].countApNew + (appInfo.stat[bizYear].countApRe || 0) : 0;
    let totalLast = appInfo.stat[bizYear - 1] ? (appInfo.stat[bizYear - 1].countApNew || 0) + (appInfo.stat[bizYear - 1].countApRe || 0) : 0;
    let totalNa = appInfo.stat[bizYear] ? appInfo.stat[bizYear].countNaNew + appInfo.stat[bizYear].countNaRe : 0;
    let apNewCurrent = appInfo.stat[bizYear] ? appInfo.stat[bizYear].countApNew : 0;
    let apNewLast = appInfo.stat[bizYear - 1] ? appInfo.stat[bizYear - 1].countApNew : 0;
    let apOld = appInfo.stat[bizYear] ? appInfo.stat[bizYear].countApOld : 0;
    let naNew = appInfo.stat[bizYear] ? appInfo.stat[bizYear].countNaNew : 0;
    let apReCurrent = appInfo.stat[bizYear] ? appInfo.stat[bizYear].countApRe : 0;
    let apReLast = appInfo.stat[bizYear - 1] ? appInfo.stat[bizYear - 1].countApNew + appInfo.stat[bizYear - 1].countApRe : 0;
    let naRe = appInfo.stat[bizYear] ? appInfo.stat[bizYear].countNaRe : 0;
    let apRe = 0;
    let quan = appInfo.stat[bizYear] ? appInfo.stat[bizYear].quantity : 0;
    let apReTarget = 0;
    let titleNew = "신규";
    let titleRe = "재계약";
    let titleReRate = "재계약율";
    let titleChildCount = "이용 원아수";
    let width = bizYear < 2024 ? 23 : 18;
    if (appInfo && appInfo.id == "keezle") {
        titleNew = "신규";
        titleRe = "계약 유지";
        titleReRate = "재계약";
        totalCurrent = appInfo.stat[bizYear] ? appInfo.stat[bizYear].countApNew + (appInfo.stat[bizYear].countApRe || 0) + (appInfo.stat[bizYear].countApOld || 0) : 0;
        apReTarget = appInfo.stat[bizYear] ? appInfo.stat[bizYear].countReTarget : 0;
        apRe = appInfo.stat[bizYear] ? appInfo.stat[bizYear].countApRe : 0;
        apReLast = appInfo.stat[bizYear - 1] ? appInfo.stat[bizYear - 1].countApNew + appInfo.stat[bizYear - 1].countApRe + appInfo.stat[bizYear - 1].countApOld : 0;
        totalNa = appInfo.stat[bizYear]
            ? appInfo.stat[bizYear].countWtRe + appInfo.stat[bizYear].countNaRe - (appInfo.stat[bizYear - 1] ? appInfo.stat[bizYear - 1].countWtNew + appInfo.stat[bizYear - 1].countNaRe : 0)
            : 0;
    }
    return (
        <div className="row mb-3">
            {appInfo && appInfo.id != "keezle" && (
                <>
                    <div style={{ width: `${width}%`, margin: "1%" }}>
                        <CardStatContract id={"year-stat-total"} title={"계약 수"} totalCurrent={totalCurrent} totalLast={totalLast} totalNa={totalNa} bSelectable={false} />
                    </div>
                    <div style={{ width: `${width}%`, margin: "1%" }}>
                        <CardStatContract id={"year-stat-new"} title={titleNew} totalCurrent={apNewCurrent} totalLast={apNewLast} totalNa={naNew} />
                    </div>
                    <div style={{ width: `${width}%`, margin: "1%" }}>
                        <CardStatContract id={"year-stat-re"} title={titleRe} totalCurrent={apReCurrent} totalLast={apReLast} totalNa={naRe} />
                    </div>
                    <div style={{ width: `${width}%`, margin: "1%" }}>
                        <CardStatContractAppRe id={"year-stat-re"} title={titleReRate} totalCurrent={apReCurrent} totalLast={apReLast} />
                    </div>
                    {bizYear > 2023 && (
                        <div style={{ width: `${width}%`, margin: "1%" }}>
                            <CardStatContractAppRe id={"year-stat-re-target-keezle"} title={titleChildCount} totalCurrent={quan} />
                        </div>
                    )}
                </>
            )}
            {appInfo && appInfo.id == "keezle" && (
                <>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                        <CardStatContract id={"year-stat-total"} title={"계약 수"} totalCurrent={totalCurrent} totalLast={totalLast} totalNa={totalNa} bSelectable={false} />
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                        <CardStatContract id={"year-stat-new"} title={titleNew} totalCurrent={apNewCurrent} totalLast={apNewLast} totalNa={naNew} />
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                        <CardStatContract id={"year-stat-old"} title={titleRe} totalCurrent={apOld} totalLast={apReLast} totalNa={naRe} />
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                        <CardStatContractAppRe id={"year-stat-re-target-keezle"} title={titleReRate} totalCurrent={apRe} totalLast={apReTarget} />
                    </div>
                </>
            )}
        </div>
    );
};

export default CardStatContractApp;
